import { Image } from '@/atoms/Image'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

const imgKidImg2 = '/v1760542713/theatrical/david/nitzevet-zeruiah-isolated-characters2'

export function ClaimTicketSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full bg-[#f9b74b] px-[16px] pb-[96px] pt-[80px] md:flex md:items-center md:px-[64px] md:py-[160px]">
      <div className="mx-auto w-full max-w-[1440px] md:flex md:items-center">
        {/* Character Image */}
        <div className="flex items-center justify-center self-stretch pb-[2.5rem] md:flex-[1_0_0] md:pb-0">
          <Image
            alt=""
            className="aspect-square w-full max-w-[692px] object-cover"
            src={imgKidImg2}
            width={692}
            height={692}
          />
        </div>

        {/* Content */}
        <div className="flex w-full flex-col items-start gap-[40px] self-stretch px-0 md:flex-[1_0_0] md:justify-center md:py-[64px] md:pl-[64px] md:pr-0">
          <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px] not-italic text-[#411e09]">
            <p className="font-angel-royal relative w-full shrink-0 text-[40px] lowercase not-italic leading-[40px] text-[#411e09] md:text-[64px] md:leading-[64px]">
              {t('davidNeedHelpTitle', 'Need Help getting Tickets?')}
            </p>
            <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#411e09] md:text-[18px] md:leading-[28px]">
              {t(
                'davidNeedHelpDescription',
                "Thanks to generous supporters, you can claim a free ticket to see DAVID in theaters. If cost is holding you back, we've got you covered - this story is for everyone.",
              )}
            </p>
          </div>

          <div className="relative flex w-full shrink-0 content-stretch items-center gap-[12px] md:w-auto">
            <DavidButton
              variant="dark"
              href={`${paths.getBaseURL()}/tickets/david?promo=claim-free-ticket`}
              className="w-full min-w-0 md:w-auto md:min-w-[200px]"
            >
              {t('claimFreeTickets', 'Claim Free Tickets')}
            </DavidButton>
          </div>
        </div>
      </div>
    </section>
  )
}
